import { isTestEnv } from '@/constant';
import user from '@/stores/user';
import { clearLazbubuData as clearLazbubuDataUtil } from '@/utils/graph';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useState } from 'react';

const DebugPage: React.FC = observer(() => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    // No endpoint memo needed; handled inside util

    const handleClear = useCallback(async () => {
        setError('');
        setLoading(true);
        try {
            const success = await clearLazbubuDataUtil(user.chainId);
            if (success) {
                user.getLazbubuData();
            } else {
                setError('Mutation failed or unexpected response.');
            }
        } catch (e: any) {
            setError(e?.message || 'Request failed');
        } finally {
            setLoading(false);
        }
    }, []);

    if (!isTestEnv) {
        return (
            <Box className="p-6">
                <Typography variant="h6">
                    Debug is only available in test environment.
                </Typography>
            </Box>
        );
    }

    return (
        <Box className="p-6 max-w-2xl mx-auto">
            <Typography variant="h5" className="mb-4">
                Debug
            </Typography>
            <Card className="mb-6">
                <CardContent>
                    <div className="mb-4">
                        <Typography
                            variant="subtitle1"
                            className="font-semibold"
                        >
                            Updated lazbubuData
                        </Typography>
                        <Typography
                            variant="body2"
                            className="break-all text-gray-700"
                        >
                            {user?.userLazbubuInfo?.lazbubuData || '(empty)'}
                        </Typography>
                    </div>
                    {error && (
                        <Typography color="error" className="mb-2">
                            {error}
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClear}
                        disabled={loading}
                    >
                        {loading ? 'Processing...' : 'Clear lazbubuData'}
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
});

export default DebugPage;
